module.exports = __webpack_public_path__ + "static/img/tu1.fc2da3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tu1.png
// module id = /qig
// module chunks = 128